import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const locationQRRoutes = [
    {
        key: "qr-summary",
        exact: true,
        path: `${APP_PREFIX_PATH}/location-qr/summary`,
        component: React.lazy(() => import("views/app-views/location-qr/pages/QrSummary")),
    },
    {
        key: "qr-locations",
        exact: true,
        path: `${APP_PREFIX_PATH}/location-qr/locations`,
        component: React.lazy(() => import("views/app-views/location-qr/pages/Locations")),
    },
    {
        key: "qr-scan-log",
        exact: true,
        path: `${APP_PREFIX_PATH}/location-qr/scan-log`,
        component: React.lazy(() => import("views/app-views/location-qr/pages/QrScanLog")),
    },
];